import { Box, Tab, Tabs } from "@mui/material";
import React, { useRef, useState } from "react";
import Parceiro from "../../components/classes/Parceiro";
import AcompanhamentoCargaGridMateriaPrima from "./gridMateriaPrima";

import styles from './detail.module.css';

export default function AcompanhamentoCargaMateriaPrimaDetalhes() {
  const [tab, setTab] = useState<string>("fob");
  const parceiro: Parceiro = JSON.parse(
    String(localStorage.getItem("ParceiroSelecionado"))
  );

  return (
    <div className={styles.table}>
      <div className={`insiderContainer ${styles.table} ${styles['d-flex']}`}>
        <Box sx={{ width: "100%" }} className={styles.table}>
          <div
            style={{
              backgroundColor: "#FFFAFA",
              scrollBehavior: "auto",
            }}
            className={styles.table}
          >
            <AcompanhamentoCargaGridMateriaPrima />
          </div>
        </Box>
      </div>
    </div>
  );
}
